/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_GreatInputs */

const en_confirm_great = /** @type {(inputs: Confirm_GreatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Great job!`)
};

const he_confirm_great = /** @type {(inputs: Confirm_GreatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`כל הכבוד!`)
};

/**
* | output |
* | --- |
* | "Great job!" |
*
* @param {Confirm_GreatInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const confirm_great = /** @type {((inputs?: Confirm_GreatInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_GreatInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_confirm_great(inputs)
	return he_confirm_great(inputs)
});